// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"369":"60f86d88","622":"7c03cd17"}[chunkId] + ".chunk.css";
};